// extracted by mini-css-extract-plugin
export default {"sol":"Payment_sol__3EzqJ"};